import React from 'react'

import bg from './../../resources/RoadMapResources/q2-bg.svg'
import '../../styles/RoadMapStyles/boardleft.css'
import '../../styles/RoadMapStyles/board.css'

import pleft from './../../resources/HomePageResources/platform-up-left.svg'
import pright from './../../resources/HomePageResources/platform-up-right.svg'

import checked from './../../resources/RoadMapResources/checked.svg'

export default class BoardLeft extends React.Component{
    render(){
        return(
            <div className="board__container">

                <div className="board__content">

                    <div className="board__information">
                        <div className="board__quater">Q{this.props.quater}</div>
                        <div className="board__year">{this.props.year}</div>
                        <div className="board__indi-box">
                            {Object.keys(this.props.items).map((key, index) => {
                                return(
                                    <div className="board__indi-info">
                                        <img className="board__checked" src={this.props.cimg} />
                                        <div>{this.props.items[index]}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className="board__bg">
                        <img className="board__bg-img" src={this.props.bgimg} />
                    </div>
                </div>

                <div className="board__plat">
                    <img src={pleft} />
                    <div className="board__plat-p"/>
                    <img src={pright} />
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/RoadMap/BoardLeft.js